import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import HeaderAvailability from './HeaderAvailability';
import ListAvailability from './ListAvailability';
import PeriodForm from './PeriodForm';
import AvailabilityForm from './AvailabilityForm';
import TemplateForm from './TemplateForm';
import i18next from 'i18next';

import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';

import { getAllLists } from '../../../actions/availability';
import * as StatusCode from '../../../scripts/StatusCode';

import AlertAlgo from '../../controls/AlertSnack'

import styles from '../../../styles/scheduleAvailability.module.css';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    toolBar: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    titleTemplate: {
        fontSize: '20px',
        '@media (max-width: 600px)': {
            fontSize: '15px',
        }
    }
}));

export function Availability(props) {
    const classes = useStyles();

    const [dataPeriodForm, setDataPeriodForm] = useState([]);
    const [dataAvailabilityOriginal, setDataAvailabilityOriginal] = useState([]);
    const [dataTemplateForm, setDataTemplateForm] = useState([]);
    const [openPeriodForm, setOpenPeriodForm] = useState(false);
    const [openAvailabilityForm, setOpenAvailabilityForm] = useState(false);
    const [openTemplateForm, setOpenTemplateForm] = useState(false);
    const [titlePeriodForm, setTitlePeriodForm] = useState('');
    const [titleAvailibilityForm, setTitleAvailibilityForm] = useState('');
    const [listRef, setListRef] = useState(null);
    const [period, setPeriod] = useState(0);
    const [lineId, setLineId] = useState(0);
    const [hasAvailability, setHasAvailability] = useState(true);
    const [comment, setComment] = useState(null);
    const alertRef = useRef(null);

    useEffect(() => {
        loadList();
        resizeForm();
    }, []);

    const resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const menu = document.querySelector('#menuFavorite').clientHeight;
            const offSet = 0;

            const customHeight = height - titleBar - menu - offSet;

            const element = document.querySelector('#divAvailability');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 100);
    }

    const loadList = () => {
        return new Promise(async (resolve) => {
            var response = await getAllLists();

            if (response != null && response.status == StatusCode.STATUS_OK) {
                setDataPeriodForm(response.periods);
                setDataAvailabilityOriginal(response.availabilities);
                setDataTemplateForm(response.templates);
            } else {
                showMessageError(i18next.t('error:generic-error'));
            }
            resolve();
        })
    }

    const handleReloadPeriod = () => {
        loadList();
        setOpenPeriodForm(false);
        showMessageSuccess(i18next.t('scheduleAvailability:period.message.success'));
    }

    const handleReloadList = async (mode = 0) => {
        // mode 0 => insert/edit
        // mode 1 => delete
        // mode 2 => create from template

        await loadList();
        handleLoadList(period);
        setOpenAvailabilityForm(false);
        setOpenTemplateForm(false);

        let message = '';
        switch (mode) {
            case 0:
                message = i18next.t('scheduleAvailability:availability.message.success');
                break;
            case 1:
                message = i18next.t('scheduleAvailability:list.message.deleteSuccess');
                break;
            case 2:
                message = i18next.t('scheduleAvailability:template.message.success');
                break;
        }
        showMessageSuccess(message);
    }

    const handleEditPeriod = (id) => {
        if (id > 0) {
            setTitlePeriodForm(i18next.t("scheduleAvailability:period.titleEdit"));
        } else {
            setTitlePeriodForm(i18next.t("scheduleAvailability:period.titleAdd"));
        }

        setPeriod(id);
        setOpenPeriodForm(true);
    }

    const handleEditAvailability = (id, lineId) => {
        if (lineId > 0) {
            setPeriod(id);
            setLineId(lineId);
            setTitleAvailibilityForm(i18next.t("scheduleAvailability:availability.titleEdit"));
        } else {
            setLineId(0);
            setTitleAvailibilityForm(i18next.t("scheduleAvailability:availability.titleAdd"));
        }

        setOpenAvailabilityForm(true);
    }

    const handleCreateTemplate = (id) => {
        if (id > 0) {
        }

        setOpenTemplateForm(true);
    }

    const handleClosePeriodForm = () => {
        setOpenPeriodForm(false);
    }

    const handleCloseAvailabilityForm = () => {
        setOpenAvailabilityForm(false);
    }

    const handleCloseTemplateForm = () => {
        setOpenTemplateForm(false);
    }

    const showMessageSuccess = (message) => {
        alertRef.current.showMessageSuccess(message);
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const handleLoadList = async (id) => {
        const rows = await listRef.loadData(id);
        setHasAvailability(rows > 0);
        setPeriod(id);
    }

    return (
        <div id="divAvailability" className={styles.rootScheduleBody}>
            <HeaderAvailability
                handleEditPeriod={handleEditPeriod}
                handleEditAvailability={handleEditAvailability}
                handleCreateTemplate={handleCreateTemplate}
                handleLoadList={handleLoadList}
                dataPeriod={dataPeriodForm}
                hasAvailability={hasAvailability}
                listRef={listRef}
                setComment={setComment}
            />
            <ListAvailability setListRef={(ref) => setListRef(ref)} data={dataAvailabilityOriginal} handleEditAvailability={handleEditAvailability} handleReloadList={handleReloadList} comment={comment} showMessageError={showMessageError} />
            <Dialog fullScreen open={openAvailabilityForm} onClose={handleCloseAvailabilityForm} TransitionComponent={Transition}>
                <div data-id="headerAvailabilityForm">
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseAvailabilityForm} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.title}>
                                {titleAvailibilityForm}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>

                <div className={styles.rootEditPeriod}>
                    <AvailabilityForm data={dataAvailabilityOriginal} handleReloadList={handleReloadList} scheduleAvailabilityId={period} lineId={lineId} />
                </div>
            </Dialog>
            <Dialog fullScreen open={openPeriodForm} onClose={handleClosePeriodForm} TransitionComponent={Transition}>
                <div data-id="headerPeriodForm">
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleClosePeriodForm} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.title}>
                                {titlePeriodForm}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>

                <div className={styles.rootEditPeriod}>
                    <PeriodForm data={dataPeriodForm} handleReloadPeriod={handleReloadPeriod} scheduleAvailabilityId={period} />
                </div>
            </Dialog>
            <Dialog fullScreen open={openTemplateForm} onClose={handleCloseTemplateForm} TransitionComponent={Transition}>
                <div data-id="headerTemplateForm">
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseTemplateForm} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{fontSize: '1.25rem'}} className={classes.titleTemplate}>
                                {i18next.t('scheduleAvailability:template.title')}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>

                <div className={styles.rootEditPeriod}>
                    <TemplateForm dataTemplate={dataTemplateForm} handleReloadList={handleReloadList} scheduleAvailabilityId={period} />
                </div>
            </Dialog>
            <AlertAlgo ref={alertRef} />
        </div>
    );
}

export default withNamespaces(['menu', 'scheduleAvailability', 'error'], { wait: true })(Availability);